import { DriverAdminService } from './../../driveradmin/models/driveradmin.service';
import { Router } from '@angular/router';
import { BookingService } from './../../booking/models/booking.service';
import { VehicleOverviewModel } from './../../booking/models/vehicle-overview.model';
import { SearchBookingModel } from './../../booking/models/search-booking.model';
import { DriverSubscriptionModel } from './../../driver/models/driver.model';
import { DriverService } from './../../driver/models/driver.service';
import { BookingOverviewList } from './../../booking/models/booking-overviewlist.model';
import { DriverDashboardService } from './../models/driver-dashboard.service';
import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import {
  DataListModel,
  ApplicationRouteURL,
  WeGoConfig
} from './../../shared/config';
import { Component, OnInit, ViewChild, LOCALE_ID } from '@angular/core';

@Component({
  selector: 'wego-driver-dashboard',
  template: require('../views/driver-dashboard.component.html'),
  providers: [
    DriverDashboardService,
    DriverService,
    BookingService,
    DriverAdminService
  ]
})
export class DriverDashboardComponent implements OnInit {
  private searchBookingModel: SearchBookingModel;
  private vehicleOverviewList: VehicleOverviewModel[];
  DataListModel: DataListModel;
  bookingList: BookingOverviewList[];
  driverSubscriptionList: DriverSubscriptionModel[];
  activeSubscription: DriverSubscriptionModel;
  apiErrorMsg: string;
  isLoading: boolean;
  isBanned: boolean = false;
  urlDriverBookingInformation: string;
  private isDriverHashID: boolean = false;
  private isLicenceRequired: boolean;
  popupDescription: string;
  initialPaymentPopupTitle: string;
  public isAllowInitialPaymentValue: boolean = false;
  popupMsg: string;
  popupTitle: string;
  isSuccess: boolean;
  errorMessage: string;
  bookingHashId: string;
  private timezoneStartDateTime: string = '';

  @ViewChild('creditCardPaymentModal') public creditCardPaymentModal: any;
  @ViewChild('successPopup') public successPopup: any;

  constructor(
    private driverDashboardService: DriverDashboardService,
    private driverService: DriverService,
    private driverAdminService: DriverAdminService,
    private translate: TranslateService,
    private authService: AuthService,
    private router: Router,
    private bookingService: BookingService
  ) {}

  ngOnInit() {
    this.activeSubscription = new DriverSubscriptionModel();
    this.searchBookingModel = new SearchBookingModel();
    this.urlDriverBookingInformation = this.authService.GetURL(
      ApplicationRouteURL.URL_BOOKING_INFORMATION_DRIVER
    );
    this.CurrentDriverDetail();
    this.GetUpcomingBooking();
    //this.GetActiveSubscription();
  }

  public GetUpcomingBooking() {
    this.isLoading = true;
    this.DataListModel = new DataListModel();
    this.DataListModel.currentPage = 1;
    this.DataListModel.itemsPerPage = 6;
    this.driverDashboardService
      .GetUpcomingBooking(this.DataListModel)
      .subscribe(
        (res: any) => {
          this.bookingList = res.data;
          this.DataListModel.totalItems = res.totalRecords;
          this.DataListModel.infoMessage = res.error;
          this.isLoading = false;
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public ConfirmSuccessPopup(): void {
    location.reload();
  }

  // public GetActiveSubscription() {
  //   this.isLoading = true;
  //   this.driverService.GetDriversSubscriptionDetail()
  //     .subscribe(
  //     res => {
  //       this.driverSubscriptionList = res.data;
  //       this.driverSubscriptionList = this.driverSubscriptionList ? this.driverSubscriptionList.filter(x => x.isActive) : [];
  //       if (this.driverSubscriptionList && this.driverSubscriptionList.length > 0)
  //         this.activeSubscription = this.driverSubscriptionList[0];
  //       this.isLoading = false;
  //     },
  //     error => {
  //       this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
  //       this.isLoading = false;
  //     });
  // }

  public OnSearch($event: any) {
    this.searchBookingModel = $event.SearchModel;
    this.vehicleOverviewList = $event.VehicleOverview;
    this.authService.searchBookingModel = this.searchBookingModel;
    this.authService.vehicleOverviewModel = this.vehicleOverviewList;
    let url = this.authService.GetURL(ApplicationRouteURL.URL_BOOKING);
    this.router.navigate([url]);
  }

  public CurrentDriverDetail() {
    this.driverAdminService.GetCurrentDriverDetail().subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res.data) {
          this.searchBookingModel.driverHashId = res.data.driverMasterHashId;
          this.isBanned = res.data.isBanned;
          this.isLicenceRequired = res.data.isLicenceRequired;
          this.searchBookingModel.isRecurringBookingAllow =
            res.data.isRecurringBookingAllow;
          this.timezoneStartDateTime = res.data.startDateTime;
          this.IsDriverHashID();
        }
      },
      (error: any) => {
        this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        this.isLoading = false;
      }
    );
  }

  private IsDriverHashID() {
    this.isDriverHashID = this.searchBookingModel.driverHashId ? true : false;
  }

  public OnPayment(bookingHashId: string, recurringId: string) {
    this.isLoading = true;
    this.bookingHashId = bookingHashId;
    this.bookingService
      .ConfirmRecurringPaymentBooking(bookingHashId, recurringId)
      .subscribe(
        (res: any) => {
          this.isLoading = false;
          if (res.data) {
            if (res.data.askForInitialPayment) {
              this.popupDescription = this.translate.instant(
                'LblPaymentDescription',
                [res.data.initialPaymentAmount]
              );
              if (res.data.isPaymentSuccess || res.data.isFirstTimePayment) {
                this.initialPaymentPopupTitle = this.translate.instant(
                  'LblFirstBooking'
                );
              } else {
                this.initialPaymentPopupTitle = this.translate.instant(
                  'LblPaymentFailed'
                );
              }
              this.isAllowInitialPaymentValue = false;
              this.creditCardPaymentModal.show();
            } else if (
              !res.data.askForInitialPayment &&
              res.data.isPaymentSuccess
            ) {
              this.isLoading = true;
              //call api
              this.bookingService
                .UpdateBookingAfterSuccessfulPayment(this.bookingHashId)
                .subscribe((res: any) => {
                  this.isLoading = false;
                  this.popupMsg = res.data;
                  this.ShowSuccessPopup();
                });
            } else {
            }
          } else {
            this.popupTitle = this.translate.instant('LblWarning');
            this.popupMsg = res.error;
            this.isSuccess = false;
            // this.ShowSuccessPopup();
          }
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public GetInitialPaymentValue(isAllowInitialPayment: any) {
    this.isAllowInitialPaymentValue = isAllowInitialPayment;
  }

  public ConfirmInitialPayment(): void {
    this.isLoading = true;
    if (this.isAllowInitialPaymentValue == false) {
      this.isLoading = false;
      const errorMessage = this.translate.instant('LblCheckAllowPayment');
      this.errorMessage = errorMessage + ':' + Date.now().toString();
    } else {
      this.searchBookingModel.bookingMasterHashId = this.bookingHashId;
      this.searchBookingModel.isFromMobileSide = false;
      this.bookingService
        .StartInitialPayment(this.searchBookingModel)
        .subscribe(res => {
          if (res.data.redirectURL) {
            this.isLoading = false;
            window.location.href = res.data.redirectURL;
          } else {
            this.isLoading = false;
            this.creditCardPaymentModal.hide();
            this.popupMsg = res.error;
            this.ShowSuccessPopup();
          }
        });
    }
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public GetImageURL(imagePath: string) {
    return WeGoConfig.API_SERVER_URL + imagePath;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/dashboard/components/driver-dashboard.component.ts